import { useQueries } from '@tanstack/vue-query';
import { portfolioFetch } from '@/api/apiMain';
import { computed, ComputedRef } from 'vue';
import { AddressInfo, PortfolioElementO } from '@/types';

export default function useAddressesData(params: AddressInfo[]) {
  const queries = computed(() =>
    params.map((param) => ({
      queryKey: ['walletPortfolio', param.address, param.addressSystem],
      queryFn: () => portfolioFetch(param.address, param.addressSystem),
      staleTime: 1000 * 15,
      gcTime: 1000 * 60 * 60 * 24 * 5,
      refetchOnWindowFocus: false,
    })),
  );

  const data = useQueries({
    queries,
  });

  const isLoading = computed(() => data.value.some((d) => d.isFetching));

  const refetch = () => data.value.forEach((d) => d.refetch());

  const elements: ComputedRef<PortfolioElementO[]> = computed(() => {
    return data.value.flatMap((w) =>
      w?.data?.elements ? w.data.elements : [],
    );
  });

  const tokenInfos = computed(() => {
    return data.value.flatMap((w) => w?.data?.tokenInfo!);
  });

  const dataUpdatedAt = computed(() => {
    const dates = data.value.flatMap((w) => w?.dataUpdatedAt!);
    return dates.length > 0 ? Math.max(...dates) : null;
  });

  return {
    elements,
    tokenInfos,
    isLoading,
    refetch,
    dataUpdatedAt,
  };
}
